<template>
  <div class="summary-table" :class="className" v-inview="{ callback: onInview }">
    <table class="summary-table__table">
      <thead class="summary-table__head" :style="`background-color: ${headColor};`">
        <tr class="summary-table__row">
          <th class="summary-table__col" v-for="(label, index) in labels" :key="`${index}_${label}`">{{ label }}</th>
        </tr>
      </thead>
      <tbody class="summary-table__body">
        <tr class="summary-table__row" v-for="{ party, votes, proportion, offsetProportion, offsetVotes } in data" :key="party"
          :style="`background-color: ${partyTableColors[party]};`">
          <td class="summary-table__col"><!--
          --><div class="summary-table__party">
              <SvgSymbol :use="`#party-${party}`"/>
            </div>
          </td>
          <td class="summary-table__col">{{ votes | numeric }}</td>
          <td class="summary-table__col">{{ proportion | percentage }}</td>
          <td class="summary-table__col">
            <div class="summary-table__offset">
              <div class="summary-table__offset-proportion"
                :class="getOffsetStateClassName(offsetProportion)"
                :style="`color: ${partyColors[party]}; border-color: ${partyColors[party]};`"><!--
              --><span class="summary-table__offset-value">{{ offsetProportion | unsign | percentage }}</span>
              </div>
              <div class="summary-table__offset-votes"><!--
              --><span class="summary-table__offset-value">{{ offsetVotes | sign | numeric }}</span>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { PARTY_COLORS, PARTY_TABLE_COLORS } from '@/constant'
export default {
  name: 'SummaryTable',
  props: {
    labels: { type: Array, default: () => [ '', '得票數', '得票率', '較上屆' ] },
    data: { type: Array, default: () => [] },
    headColor: { type: String, default: '#a1a1a1' }
  },
  data () {
    return {
      isInview: false,
      partyColors: PARTY_COLORS,
      partyTableColors: PARTY_TABLE_COLORS
    }
  },
  computed: {
    className () {
      return {
        'summary-table--inview': this.isInview
      }
    }
  },
  methods: {
    onInview () {
      this.isInview = true
    },
    getOffsetStateClassName (offsetValue) {
      if (offsetValue > 0) {
        return {
          'summary-table--offset-up': true
        }
      } else if (offsetValue < 0) {
        return {
          'summary-table--offset-down': true
        }
      }
      return {}
    }
  }
}
</script>

<style lang="scss">
.summary-table {
  $comp: &;
  margin-top: 20px;
  @include rwd($RWD_DESKTOP_WIDE) {
    margin-top: 27px;
  }

  &__table {
    width: 100%;
    text-align: center;
    opacity: 0;
    transform: translateY(10px);
  }

  &__head {
    #{$comp}__col {
      font-size: 0.8125em;
      font-weight: 500;
      @include rwd($RWD_TABLET_SMALL) {
        font-size: 0.9375em;
      }
      @include rwd($RWD_TABLET) {
        font-size: 1em;
      }
    }
  }

  &__body {
    #{$comp}__col {
      font-size: 1em;
      @include rwd($RWD_TABLET_SMALL) {
        font-size: 1.125em;
      }
      @include rwd($RWD_TABLET) {
        font-size: 1.25em;
      }
    }
  }

  &__row {}

  &__col {
    padding: 10px 0;
    line-height: 1em;
    border: 1px solid white;
  }

  &__party {
    display: inline-block;
    width: 20px;
    height: 20px;
    vertical-align: middle;
    overflow: hidden;
    @include rwd($RWD_TABLET_SMALL) {
      width: 22px;
      height: 22px;
    }
    @include rwd($RWD_TABLET) {
      width: 25px;
      height: 25px;
    }
  }

  &__offset {
    display: inline-block;
    // text-align: left;
  }

  &__offset-proportion {
    &:before {
      content: "";
      display: none;
      vertical-align: middle;
      border-width: 0 6px 6px 6px;
      border-style: solid;
      border-color: transparent;
      border-bottom-color: inherit;
    }
    &#{$comp}--offset-up {
      &:before {
        display: inline-block;
        margin-right: 5px;
      }
    }
    &#{$comp}--offset-down {
      &:before {
        display: inline-block;
        margin-right: 5px;
        transform: scaleY(-1);
      }
    }
  }

  &__offset-votes {
    margin-top: 8px;

    #{$comp}__offset-value {
      position: relative;
      display: inline-block;
    }

    // #{$comp}__offset-value:after {
    //   content: "";
    //   display: block;
    //   position: absolute;
    //   left: 0;
    //   bottom: -2px;
    //   width: 100%;
    //   border-top: 1px solid #fcc230;
    // }
  }

  &__offset-value {
    vertical-align: middle;
  }

  &--inview {
    #{$comp}__table {
      opacity: 1;
      transform: translateY(0);
      transition:
        opacity 0.4s ease 1.2s,
        transform 0.4s ease 1.2s;
    }
  }
}
</style>
